// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__38fVa","header":"MessagesList_header__1kRcK","chat":"MessagesList_chat__2qS0A"};